import { useEffect, useState } from 'react';
import './App.css';
import AppRouter from './route/AppRouter';
import { auth } from './utitilties/firebase';

function App() {

  const [initailised, setIntialised] = useState(false)

  const authInitialise = () => {
    auth.onAuthStateChanged((user) => {
      setIntialised(true)


    })
  }



  useEffect(() => {
    authInitialise()

    return authInitialise()
  }, [])

  if (!initailised) return null
  
  return (
    <AppRouter />
  );
}

export default App;
